import React, {useRef, useState} from "react";


import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {Employee} from "../../../app/interfaces";
import {updateEmployeeState} from "../../../app/employee/selectors";
import {
    downloadBase64File,
    EMPLOYMENT_STATUS_EOR_QUOTE_REQUESTED,
    EMPLOYMENT_STATUS_IN_REGISTRATION, FETCH_STATUS_LOADING
} from "../../../utils/constants";
import {PopupAskForConfirmation, PopupLoading, PrimaryButton} from "../../../components";
import {completeRegistration, updateEmployee} from "../../../app/employee/actions";
import {ConcludeRegistration, ContractUploader, StatusActionContainer} from "./style";
import {PreviewEorInvoice} from "./style";
import {ReactComponent as UploadClip} from "../../../assets/icons/clip_upload.svg";
import {ReactComponent as CloseRounded} from "../../../assets/icons/close_rounded.svg";
import {isValidString} from "../../../utils";

const RegistrationActions = ({employee}:{employee:Employee}) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const updateStatus = useSelector(updateEmployeeState);

    const [showModalConfirmRegistered, setShowModalConfirmRegistered] = useState(false);
    const [newContractFile, setNewContractFile] = useState<{file_name: string, base64: string}>({file_name: '', base64: ''})

    const fileInputRef = useRef<HTMLInputElement>(null);
    const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files && e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setNewContractFile({
                    base64: reader.result as string,
                    file_name: file.name
                });
            };
            reader.readAsDataURL(file);
        }
    };

    const handleUploadClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleRemoveInvoiceFile = () => {
        setNewContractFile({
            base64: '',
            file_name: ''
        })
    }

    let title;
    let description;
    let buttonTitle;
    let onClick:Function = () => null;

    if(employee.status === EMPLOYMENT_STATUS_EOR_QUOTE_REQUESTED){
        title = t('quote_requested_cta_title')
        description = t('quote_requested_cta_description',
            {company_name: employee.company.name})
        buttonTitle = t('quote_requested_cta_btn')
        onClick = () => navigate(`/generate_quote/${employee._id}`)
    } else if(employee.status === EMPLOYMENT_STATUS_IN_REGISTRATION){
        title = t('mark_employee_as_register_title');
        description = t('mark_employee_as_register_message')
        buttonTitle = t('mark_employee_as_register_button_title')
        onClick = () => {setShowModalConfirmRegistered(true)}
    }else{
        return null;
    }

    if (updateStatus === FETCH_STATUS_LOADING) {
        return <PopupLoading isOpen={true}/>
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const handleStartRegistration = () => {
        dispatch(updateEmployee({
            employeeId: employee._id,
            companyId: employee.company._id,
            status: EMPLOYMENT_STATUS_IN_REGISTRATION
        }) as any)
    }

    const handleCompleteRegistration = async () => {
        setShowModalConfirmRegistered(false)
        dispatch(completeRegistration({
            companyId: employee.company._id,
            employeeId: employee._id,
            contract: newContractFile.base64
        }) as any)
    }

    return <StatusActionContainer>
        <h1>
            {title}
        </h1>
        <p>{description}</p>
        {employee.status === EMPLOYMENT_STATUS_IN_REGISTRATION ? <ConcludeRegistration>
            <input type='file' accept='.pdf' onChange={handleFileInputChange}
                   ref={fileInputRef}/>
            {newContractFile.base64 && newContractFile.file_name ?
                <PreviewEorInvoice>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                        href="#"
                        onClick={() => {
                            downloadBase64File(
                                newContractFile.base64,
                                newContractFile.file_name
                            )
                        }}>
                        {newContractFile.file_name}
                    </a>
                    <CloseRounded onClick={handleRemoveInvoiceFile}/>
                </PreviewEorInvoice> :
                <ContractUploader>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a href='#' onClick={handleUploadClick}>
                        <UploadClip/> {t('upload_contract')}
                    </a>
                </ContractUploader>
                }
            <PrimaryButton disabled={!isValidString(newContractFile.file_name) || !isValidString(newContractFile.base64)} onClick={() => onClick()}>{buttonTitle}</PrimaryButton>
        </ConcludeRegistration> : <PrimaryButton onClick={() => onClick()}>{buttonTitle}</PrimaryButton>}


        <PopupAskForConfirmation
            type="warning"
            isOpen={showModalConfirmRegistered}
            title={t('ask_for_confirmation_registration_completed_title') as string}
            subtitle={t('ask_for_confirmation_registration_completed_subtitle') as string}
            confirmButtonTitle={t('ask_for_confirmation_registration_completed_confirm_button') as string}
            cancelButtonTitle={t('ask_for_confirmation_registration_completed_cancel_button') as string}
            onConfirm={handleCompleteRegistration}
            onCancel={() => {setShowModalConfirmRegistered(false)}}
        />
    </StatusActionContainer>
}

export default RegistrationActions;
